import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import initializers from '../../dependencies/initializers.js'



import imgHero from '../../images/hero_img_succession_planning.png'
import imgSectionOne from '../../images/img_succession_planning_01.png'
import imgSectionTwo from '../../images/img_succession_planning_02.png'
import imgSectionThree from '../../images/img_succession_planning_03.png'
import imgRoundedLeftTop from '../../images/rounded_left_top.png'

import { accesslog, translate } from '../../helpers/global.js'

import { usersGetDetailAsync } from '../../actions/users.js'
import { getWeeklyDemoDataAsync } from '../../actions/global';

class SuccessionPlanning extends React.Component {
	constructor(props) {
		super(props)
	}

	async componentDidMount() {
		window.scrollTo(0, 0)
    if (!this.props.weeklyDemoData || !this.props.weeklyDemoData.webinar_link) {
      await this.props.getWeeklyDemoDataAsync();
    }    

	}

  chooseOpt(val) {
		const url_api = initializers.api_host
		  if(val === '1') {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.co/'
	
			} else {
				window.location = 'https://astrnt.co/'
			}
		  } else {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.id/'
	
			} else {
				window.location = 'https://astrnt.id/'
			}
		  }
		}

  render() {
    const {
      globalGetLanguages,
      user, weeklyDemoData
    } = this.props
    const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
    return (
			<div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="banner ai">
          <section>
            <div className="ban-text apis">
              <div className="title-1">Planning for the Future</div>
              <div className="title-1">Starts with the Right</div>
              <div className="title-1">People</div>
              

              <div className='content-desc-technical'>
                Identify internal talent with leadership potential so you're ready when critical roles open up.
              </div>

              <div className={`ban-link`}>
                <Link onClick={() => {
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                  accesslog('talent-management/succession-planning', 'button_talk_to_an_expert');
                }} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
                <a href={weeklyDemoData.webinar_link} target="_blank" className={`request-demo-logged${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                  onClick={() => accesslog('talent-management/succession-planning', 'button_register_for_demo')}
                >Register for Demo</a>
              </div>
              <div className={`ban-link hide`}>
                <Link onClick={() => document.getElementById('modal_talk_expert').classList.add('show-cta-modal')} className='try'>{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
              </div>
              <a href="#" className="vid-msg">
                <img src={imgHero} />
              </a>
            </div>
          </section>
        </div>


     <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <a href="#" className="vid-msg-left-top">
            <img src={imgRoundedLeftTop} />
          </a>

          <section className='flex-container position-relative'>
            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionOne} />
              </div>
            </div>
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc-point'>
                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                  Respond Quickly To <br />Opportunity
                  </h2>
                  <p className='m-b-24'>
                    Leadership changes are inevitable. But when there's no 
                    visibility on internal talent, succession becomes a 
                    scramble. Roles are filled under pressure, and decisions 
                    are often based on intuition rather than insight.
                  </p>
                  <p className='m-b-8'>Common challenges and mistakes:</p>  
                  <ul>
                    <li><i className="fa fa-circle red" aria-hidden="true" />Promotions rely on tenure or familiarity</li>
                    <li><i className="fas fa-check" />No structure to evaluate future leaders</li>
                    <li><i className="fas fa-check" />Difficult to compare talent across departments</li>
                    <li><i className="fas fa-check" />Limited time and tools to assess potential fairly</li>
                  </ul>

                </div>
              </div>
            </div> 
          </section>
      </div>
    
    <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>

                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                  What Companies Are Doing <br />Today

                  </h2>
                  <p className='m-b-24'>
                      More organisations are shifting away from informal 
                      nominations and focusing on structured assessment and 
                      interviews. Instead of depending on reviews or manager 
                      input alone, they use simulations and job-relevant 
                      scenarios to uncover potential.
                  </p>
                  <p className='m-b-8'>This helps build succession plans based on real behavior 
                    and clear signals, not assumptions.</p>  
                </div>
              </div>
            </div> 
            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionTwo} />
              </div>
            </div>

          </section>
      </div>

    <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>

            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionThree} />
              </div>
            </div>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>

                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                  How ASTRNT Supports <br />Succession Planning

                  </h2>
                  <p className='m-b-8'>With ASTRNT, companies can:</p>
                  <ul>
                    <li><i className="fas fa-check" />Define consistent leadership criteria</li>
                    <li><i className="fas fa-check" />Assess internal candidates through structured <br />evaluations</li>
                    <li><i className="fas fa-check" />Understand readiness across teams with visual clarity</li>
                  </ul>
                  <p className='m-b-8' style={{ fontSize: '16px' }}>When used together with the NextGen Assessment Center, this 
                    process gives you a realistic view of who is ready, who is 
                    emerging, and who needs further development.</p>  

                </div>
              </div>
            </div> 
          </section>
      </div>


      <div className="section-gray single-triangle triangle-right" style={{position: 'relative'}}>
          <section className='p-t-50 p-b-50'>
            <div className='ai-interview-start'>
              <h1>Know Who’s Ready and <br />What They Need Next</h1>
              <h4> Build a structured view of your future leaders.</h4>
                <div className="ban-text-start-demo">
                <div className={`ban-link`}>
                  <Link onClick={() => {
                    document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                    accesslog('talent-management/succession-planning', 'button_talk_to_an_expert');
                  }} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
                  <a href={weeklyDemoData.webinar_link} target="_blank" className={`request-demo-logged${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                    onClick={() => accesslog('talent-management/succession-planning', 'button_register_for_demo')}
                  >Register for Demo</a>
                </div>
              </div>

            </div>
          </section>
      </div>

        
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user,
    weeklyDemoData: state.weeklyDemo.weeklyDemoData
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user)),
    getWeeklyDemoDataAsync: () => dispatch(getWeeklyDemoDataAsync())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SuccessionPlanning)
